import React, { useState } from 'react';
import styled from 'styled-components';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { DEFAULT_ORDER } from '@/lib/constants';
import {
  LinkHandler,
  Typography,
  IconArrowDown,
  CircleBullet,
} from '@/components/atoms';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { ICollectionDropdownCmp } from './ICollectionDropdownCmp';

interface IStyledProps {
  $expanded?: boolean;
  icon?: string;
  active?: boolean;
}

const UlComponent = styled.ul<IStyledProps>`
  visibility: ${props => (props.$expanded ? 'visible' : 'hidden')};
  opacity: ${props => (props.$expanded ? 1 : 0)};
  height: ${props => (props.$expanded ? '100%' : 0)};
  cursor: pointer;
  height: auto;
  z-index: 10;
  position: absolute;
  top: 100%;
  left: 0px;
  background-color: ${props => props.theme.paletteDefault.white};
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-top: 0;
  border-radius: 0 0 16px 16px;
  padding: 2px 0;
`;

const LiComponent = styled.li<IStyledProps>`
  display: flex;
  justify-content: flex-start;
  padding: 8px;
  a {
    display: block;
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
  }
`;

const WrapperDropdown = styled.div<IStyledProps>`
  cursor: pointer;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Header = styled.div<IStyledProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-bottom: ${props =>
    props.$expanded ? 0 : '1px solid rgba(0, 0, 0, 0.23)'};
  border-radius: ${props => (props.$expanded ? '16px 16px 0 0' : '16px')};
  padding: 2px 8px;
`;

const LinkWrapper = styled.div<IStyledProps>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: fit-content;
`;

const ImageArrow = styled(IconArrowDown)<IStyledProps>`
  transform: ${props => (props.$expanded ? 'none' : 'rotate(270deg)')};
`;

const StyledAnchor = styled.a<IStyledProps>`
  color: inherit;
`;
const BulletWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CollectionDropdown: React.FC<ICollectionDropdownCmp> = ({
  sortSelected,
  collectionSortOptions,
}) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { slug, ...queryParameters } = router.query;
  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded(!expanded);
  };

  const handleClickAway = () => {
    setExpanded(false);
  };

  let header;

  header = (
    <Header $expanded={expanded ? expanded : undefined}>
      <Typography datatype="caption">
        {sortSelected?.value &&
        sortSelected?.value.toLowerCase() !== DEFAULT_ORDER.toLowerCase()
          ? sortSelected.label
          : t('sort')}
      </Typography>

      <ImageArrow
        width={30}
        height={13}
        $expanded={expanded ? expanded : undefined}
      />
    </Header>
  );

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <WrapperDropdown $expanded={expanded} onClick={handleClick}>
        {header}
        <UlComponent $expanded={expanded}>
          {collectionSortOptions &&
            collectionSortOptions.map(option => {
              return (
                <LiComponent key={option?.value}>
                  <LinkWrapper>
                    {option?.value === sortSelected?.value && (
                      <BulletWrapper>
                        <CircleBullet active={true} />
                      </BulletWrapper>
                    )}
                    <Typography datatype="caption">
                      <LinkHandler
                        href={{
                          pathname: router.pathname,
                          query: {
                            slug: (slug as string[]) || [],
                            ...queryParameters,
                            sort_by: option?.value,
                          },
                        }}
                        shallow={true}>
                        <StyledAnchor>{option.label}</StyledAnchor>
                      </LinkHandler>
                    </Typography>
                  </LinkWrapper>
                </LiComponent>
              );
            })}
        </UlComponent>
      </WrapperDropdown>
    </ClickAwayListener>
  );
};

export default CollectionDropdown;
